import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/(common-header-footer)/game/[gameName]/[gameCode]/share-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/analytics/page-load-complete/page-load-complete.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/custom-links/comet-link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-cards/horizontal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-cards/square/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamePlayerAdProviderClient"] */ "/app/app/components/game-player/context/gameplayer-ads-context/gameplayer-ads-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-player/domino/domino-ui.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DominoProvider"] */ "/app/app/components/game-player/domino/domino-visiblity-context/domino-visiblity-context.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-player/gameplayer-comet-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-player/start-game-on-key-up/start-game-on-keyup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/actions-section/buttons/favourite-btn/fav-btn-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/actions-section/buttons/feedback-btn/button-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/actions-section/buttons/full-screen/full-screen-btn-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameLikeProviderClient"] */ "/app/app/components/gameplayer-page/actions-section/buttons/like-dislike-btns/game-like-provider/game-liked-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/actions-section/buttons/like-dislike-btns/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/actions-section/buttons/share-btn/share-action/actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayButtonProvider"] */ "/app/app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/game-info-section/votes-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/game-section/game-screen-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/gameplayer-page-desktop/sticky-right-side.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/gameplayer/gameplayer-visiblity-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/more-games/more-games-non-desktop/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/more-games/more-games-desktop/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/more-games/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-title/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-image-and-play-btn/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-image-and-play-btn/play-btn/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/actions-section/buttons/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/actions-section/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-section/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-info-section/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/game-info-section/breadcrumbs/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/gameplayer-page-desktop/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/preroll-ad-on-page-load.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/gameplayer-page/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/gameplayer-page/visiblity-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/analytics/visiblity-analytics-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/home-page-sections/all-tags/tag-icon-and-name/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/home-page-sections/analytics/analytics-wrapper-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/load-on-interaction/interaction-placeholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadOnUserInteractionClient"] */ "/app/app/components/load-on-interaction/load-on-interaction-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sidebar/sidebar-tags-container/animate-visiblity/animate-visiblity-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/continue-playing-slider/continue-playing-slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderAnalyticsProvider"] */ "/app/app/components/sliders/slider/analytics-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/slider/slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/text-component-section/accordion/accordion-head-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/text-component-section/event-wrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/text-component-section/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/text-component-section/accordion/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/text-component-section/visiblity-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/script/debug/debug.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamInterstitialScript"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/interstitial-ad/gam-interstitial-script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-collapser/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-not-found/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/display-ad.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentScript"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/script/consent-script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
